// extracted by mini-css-extract-plugin
export default {"wrapper":"c9_y","tooltip":"c9_l0","active":"c9_bL","top":"c9_bW","right":"c9_mz","bottom":"c9_mB","left":"c9_mC","staticLeft":"c9_fb","staticRight":"c9_mD"};